import React from "react";
import { Card, CardBody, CardHeader, Link } from "@heroui/react";
import { Link as RouterLink } from "react-router-dom";
import PageTemplate from "../components/PageTemplate";
import GTQurbani from "../Placings3.0/GTQurbani.jpeg";
import PurdueKahaani from "../Placings3.0/PurdueKahaani.png";
import WisconsinSurma from "../Placings3.0/WisconsinSurma.png";
import TexasRaas from "../Placings3.0/TexasRaas.jpg";
import UConnThunderaas from "../Placings3.0/UConnThunderaas.png";
import NEUNakhraas from "../Placings3.0/NEUNakhraas.png";

export default function History() {
  return (
    <PageTemplate>
      {/* Hero Section with Enhanced Beach Background */}
      <div className="bg-gradient-to-br from-pink-100 via-coral-100 to-cream-100 py-8 sm:py-12 lg:py-16 px-4 sm:px-6 relative overflow-hidden">
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-text font-bold text-coral mb-4 sm:mb-6 animate-fade-in drop-shadow-lg">
            Our History
          </h1>
          <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full shadow-lg"></div>
        </div>
      </div>

      {/* Enhanced Timeline Section */}
      <div className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-cream-50 relative overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-r from-lavender to-teal rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-gradient-to-r from-coral-400 to-sand-400 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-gradient-to-r from-teal to-coral rounded-full blur-2xl"></div>
        </div>
        
        <div className="max-w-6xl mx-auto relative z-10">

          <div className="timeline-container relative">
            {/* Enhanced Timeline line with gradient */}
            <div className="absolute left-4 sm:left-8 md:left-1/2 transform md:-translate-x-1/2 top-0 bottom-0 w-2 bg-lavender rounded-full shadow-lg"></div>
            
            {/* Timeline Items */}
            <div className="space-y-12 sm:space-y-16">
              
              {/* NAACH 3.0 Champions - LEFT SIDE */}
              <div className="timeline-item relative">
                <div className="timeline-marker absolute left-2 sm:left-4 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-r from-lavender to-teal rounded-full border-4 border-white shadow-xl ring-4 ring-lavender-200"></div>
                <div className="timeline-content relative z-10 ml-10 sm:ml-20 md:ml-0 md:w-5/12 md:pr-8 lg:pr-12">
                  <Card className="bg-white/90 backdrop-blur-md border-2 border-lavender-200 shadow-2xl hover:shadow-3xl transition-all duration-500 animate-fade-in overflow-hidden">
                      <CardHeader className="pb-3 sm:pb-4 bg-gradient-to-r from-cream-50 to-sky-50 flex justify-center items-center">
                        <h3 className="text-lg sm:text-xl font-text font-bold text-coral text-center">NJ NAACH 3.0 PLACINGS</h3>
                      </CardHeader>
                      <CardBody className="p-4 sm:p-6">
                        <div className="text-center">
                          {/* 6 Bubbles in 2 rows of 3 */}
                          <div className="space-y-4 mt-4">
                            {/* First Row - Legends Circuit */}
                            <div className="text-center">
                              <h4 className="text-base sm:text-lg font-text font-bold text-coral mb-3">Legends</h4>
                              <div className="flex justify-center space-x-3 sm:space-x-4">
                                <div className="text-center">
                                  <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">1st Place</p>
                                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-yellow-300 overflow-hidden">
                                    <img 
                                      src={GTQurbani} 
                                      alt="GT Qurbani" 
                                      className="w-full h-full object-cover"
                                    />
                                  </div>
                                  <p className="text-xs text-teal-600 font-text font-bold">GT Qurbani</p>
                                </div>
                                <div className="text-center">
                                  <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">2nd Place</p>
                                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-gray-400 to-gray-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-gray-300 overflow-hidden">
                                    <img 
                                      src={PurdueKahaani} 
                                      alt="Purdue Kahaani" 
                                      className="w-full h-full object-cover scale-105"
                                    />
                                  </div>
                                  <p className="text-xs text-teal-600 font-text font-bold">Purdue Kahaani</p>
                                </div>
                                <div className="text-center">
                                  <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">3rd Place</p>
                                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-orange-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-orange-300 overflow-hidden">
                                    <img 
                                      src={WisconsinSurma} 
                                      alt="Wisconsin Surma" 
                                      className="w-full h-full object-contain p-1 bg-white"
                                    />
                                  </div>
                                  <p className="text-xs text-teal-600 font-text font-bold">Wisconsin Surma</p>
                                </div>
                              </div>
                            </div>
                            
                            {/* Second Row - RAS Circuit */}
                            <div className="flex flex-col items-center">
                              <h4 className="text-base sm:text-lg font-text font-bold text-coral mb-3">Raas All Stars</h4>
                              <div className="flex space-x-3 sm:space-x-4" style={{ transform: "translateX(5%)" }}>
                                <div className="text-center">
                                  <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">1st Place</p>
                                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-blue-400 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-blue-300 overflow-hidden">
                                    <img 
                                      src={TexasRaas} 
                                      alt="Texas Raas" 
                                      className="w-full h-full object-cover"
                                    />
                                  </div>
                                  <p className="text-xs text-teal-600 font-text font-bold">Texas Raas</p>
                                </div>
                                <div className="text-center">
                                  <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">2nd Place</p>
                                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-purple-400 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-purple-300 overflow-hidden">
                                    <img 
                                      src={UConnThunderaas} 
                                      alt="UConn Thunderaas" 
                                      className="w-full h-full object-cover"
                                    />
                                  </div>
                                  <p className="text-xs text-teal-600 font-text font-bold">UConn Thunderaas</p>
                                </div>
                                <div className="text-center">
                                  <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">3rd Place</p>
                                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-pink-400 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-pink-300 overflow-hidden">
                                    <img 
                                      src={NEUNakhraas} 
                                      alt="Northeastern Nakhraas" 
                                      className="w-full h-full object-cover"
                                    />
                                  </div>
                                  <p className="text-xs text-teal-600 font-text font-bold">Northeastern Nakhraas</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                  </Card>
                </div>
              </div>

              {/* NAACH 3.0 Board - LEFT SIDE */}
              <div className="timeline-item relative">
                <div className="timeline-marker absolute left-2 sm:left-4 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-r from-lavender to-teal rounded-full border-4 border-white shadow-xl ring-4 ring-lavender-200"></div>
                <div className="timeline-content relative z-10 ml-10 sm:ml-20 md:ml-0 md:w-5/12 md:pr-8 lg:pr-12">
                  <Link as={RouterLink} to="/board" className="block">
                    <Card className="bg-white/90 backdrop-blur-md border-2 border-lavender-200 shadow-2xl hover:shadow-3xl transition-all duration-500 transform hover:scale-105 cursor-pointer overflow-hidden">
                      <CardHeader className="pb-3 sm:pb-4 bg-gradient-to-r from-cream-50 to-sky-50 flex justify-center items-center">
                        <h3 className="text-lg sm:text-xl font-text font-bold text-coral text-center">NJ NAACH 3.0 Board</h3>
                      </CardHeader>
                      <CardBody className="p-4 sm:p-6">
                        <div className="text-center">
                          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r from-lavender to-teal rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg">
                            <span className="text-white text-2xl sm:text-3xl">🏖️</span>
                          </div>
                          <p className="text-teal-600 font-text text-sm sm:text-base font-medium mb-2">
                            Meet the dedicated team behind NJ Naach 3.0
                          </p>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </div>
              </div>

              {/* NAACH 3.0 Board Photo - RIGHT SIDE */}
              <div className="timeline-item relative">
                <div className="timeline-marker absolute left-2 sm:left-4 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-r from-lavender to-teal rounded-full border-4 border-white shadow-xl ring-4 ring-lavender-200"></div>
                
                {/* Large Scrapbook Image - RIGHT SIDE */}
                <div className="absolute right-0 md:right-0 md:left-auto md:w-5/12 md:pl-8 lg:pl-12 top-0 pointer-events-none -z-10 opacity-25 sm:opacity-40 md:opacity-100 md:z-0">
                  <div className="relative inline-block transform -translate-y-[40rem] -rotate-3">
                    {/* Tape pieces - all four corners */}
                    <div className="absolute -top-3 -left-3 w-12 h-6 bg-yellow-200 opacity-80 transform -rotate-45 z-10 rounded-sm shadow-md"></div>
                    <div className="absolute -top-3 -right-3 w-12 h-6 bg-yellow-200 opacity-80 transform rotate-45 z-10 rounded-md shadow-md"></div>
                    <div className="absolute -bottom-3 -left-3 w-12 h-6 bg-yellow-200 opacity-80 transform rotate-45 z-10 rounded-md shadow-md"></div>
                    <div className="absolute -bottom-3 -right-3 w-12 h-6 bg-yellow-200 opacity-80 transform -rotate-45 z-10 rounded-sm shadow-md"></div>
                    
                    {/* Board 3.0 Image */}
                    <img 
                      src="/images/board3.0.JPG" 
                      alt="NAACH 3.0 Board" 
                      className="w-80 h-80 sm:w-[22rem] sm:h-[22rem] lg:w-[30rem] lg:h-[30rem] object-cover rounded-xl shadow-2xl border-4 border-white"
                    />
                  </div>
                </div>
              </div>

              {/* NAACH 2.0 Champions - RIGHT SIDE */}
              <div className="timeline-item relative">
                <div className="timeline-marker absolute left-2 sm:left-4 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-r from-teal to-coral rounded-full border-4 border-white shadow-xl ring-4 ring-teal-200"></div>
                
                {/* Large Scrapbook Image - LEFT SIDE */}
                <div className="absolute left-0 md:left-0 md:right-auto md:w-5/12 md:pr-8 lg:pr-12 top-0 pointer-events-none -z-10 opacity-25 sm:opacity-40 md:opacity-100 md:z-0">
                  <div className="relative inline-block transform translate-y-40 rotate-6">
                    {/* Tape pieces - diagonal corners */}
                    <div className="absolute -top-3 -left-3 w-12 h-6 bg-yellow-200 opacity-80 transform -rotate-12 z-10 rounded-sm shadow-md"></div>
                    <div className="absolute -top-3 -right-3 w-12 h-6 bg-yellow-200 opacity-80 transform rotate-12 z-10 rounded-md"></div>
                    <div className="absolute -bottom-3 -left-3 w-12 h-6 bg-yellow-200 opacity-80 transform rotate-12 z-10 rounded-md"></div>
                    <div className="absolute -bottom-3 -right-3 w-12 h-6 bg-yellow-200 opacity-80 transform -rotate-12 z-10 rounded-sm shadow-md"></div>
                    
                    {/* Large Image */}
                    <img 
                      src="/images/board2.0.png" 
                      alt="NAACH 2.0 Board" 
                      className="w-96 h-96 sm:w-[26rem] sm:h-[26rem] lg:w-[36rem] lg:h-[36rem] object-cover rounded-xl shadow-2xl border-4 border-white"
                    />
                  </div>
                </div>
                
                <div className="timeline-content relative z-10 ml-10 sm:ml-20 md:ml-auto md:w-5/12 md:pl-8 lg:pl-12">
                  <Card className="bg-white/90 backdrop-blur-md border-2 border-teal-200 shadow-2xl hover:shadow-3xl transition-all duration-500 animate-fade-in overflow-hidden">
                    <CardHeader className="pb-3 sm:pb-4 bg-gradient-to-r from-seafoam-50 to-coral-50 flex justify-center items-center">
                      <h3 className="text-lg sm:text-xl font-text font-bold text-coral text-center">NJ NAACH 2.0 PLACINGS</h3>
                      <p className="timeline-date text-xs sm:text-sm text-teal-400 font-text font-semibold"></p>
                    </CardHeader>
                    <CardBody className="p-4 sm:p-6">
                      <div className="text-center">
                        {/* 6 Bubbles in 2 rows of 3 */}
                        <div className="space-y-4 mt-4">
                          {/* First Row - Legends Circuit */}
                          <div className="text-center">
                            <h4 className="text-base sm:text-lg font-text font-bold text-coral mb-3">Legends</h4>
                            <div className="flex justify-center space-x-3 sm:space-x-4">
                              <div className="text-center">
                                <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">1st Place</p>
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-yellow-300 overflow-hidden">
                                  <img 
                                    src="/teams/GASZ.jpg" 
                                    alt="Georgia Saazish" 
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <p className="text-xs text-teal-600 font-text font-bold">Georgia Saazish</p>
                              </div>
                              <div className="text-center">
                                <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">2nd Place</p>
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-gray-400 to-gray-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-gray-300 overflow-hidden">
                                  <img 
                                    src="/teams/UNCchalka.jpg" 
                                    alt="UNC Chalka" 
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <p className="text-xs text-teal-600 font-text font-bold">UNC Chalka</p>
                              </div>
                              <div className="text-center">
                                <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">3rd Place</p>
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-orange-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-orange-300 overflow-hidden">
                                  <img 
                                    src="/teams/UGAAsura.jpg" 
                                    alt="UGA Asura" 
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <p className="text-xs text-teal-600 font-text font-bold">UGA Asura</p>
                              </div>
                            </div>
                          </div>
                          
                          {/* Second Row - RAS Circuit */}
                          <div className="flex flex-col items-center">
                            <h4 className="text-base sm:text-lg font-text font-bold text-coral mb-3">Raas All Stars</h4>
                            <div className="flex space-x-3 sm:space-x-4" style={{ transform: 'translateX(5%)' }}>
                              <div className="text-center">
                                <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">1st Place</p>
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-blue-400 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-blue-300 overflow-hidden">
                                  <img 
                                    src="/teams/neu.jpg" 
                                    alt="NEU Nakhraas" 
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <p className="text-xs text-teal-600 font-text font-bold">NEU Nakhraas</p>
                              </div>
                              <div className="text-center">
                                <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">2nd Place</p>
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-purple-400 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-purple-300 overflow-hidden">
                                  <img 
                                    src="/teams/cornell.jpg" 
                                    alt="Cornell Big Red Raas" 
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <p className="text-xs text-teal-600 font-text font-bold">Cornell Big Red Raas</p>
                              </div>
                              <div className="text-center">
                                <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">3rd Place</p>
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-pink-400 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-pink-300 overflow-hidden">
                                  <img 
                                    src="/teams/michigan.jpg" 
                                    alt="Michigan Wolveraas" 
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <p className="text-xs text-teal-600 font-text font-bold">Michigan Wolveraas</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>

              {/* NAACH 2.0 Board - RIGHT SIDE */}
              <div className="timeline-item relative">
                <div className="timeline-marker absolute left-2 sm:left-4 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-r from-teal to-coral rounded-full border-4 border-white shadow-xl ring-4 ring-coral-200"></div>
                
                <div className="timeline-content relative z-10 ml-10 sm:ml-20 md:ml-auto md:w-5/12 md:pl-8 lg:pl-12">
                  <Link as={RouterLink} to="/board-2-0" className="block">
                    <Card className="bg-white/90 backdrop-blur-md border-2 border-peach-200 shadow-2xl hover:shadow-3xl transition-all duration-500 transform hover:scale-105 cursor-pointer overflow-hidden">
                      <CardHeader className="pb-3 sm:pb-4 bg-gradient-to-r from-coral-50 to-sky-50 flex justify-center items-center">
                        <h3 className="text-lg sm:text-xl font-text font-bold text-coral text-center">NJ NAACH 2.0 Board</h3>
                      </CardHeader>
                      <CardBody className="p-4 sm:p-6">
                        <div className="text-center">
                          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r from-coral-400 to-seafoam-400 rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg">
                            <span className="text-white text-lg sm:text-xl">🏎️</span>
                          </div>
                          <p className="text-teal-600 font-text text-sm sm:text-base font-medium mb-2">
                            The team that made NAACH 2.0 possible
                          </p>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </div>
              </div>

              {/* NAACH 1.0 Champions - LEFT SIDE (BOTTOM) */}
              <div className="timeline-item relative">
                <div className="timeline-marker absolute left-2 sm:left-4 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-r from-peach to-lavender rounded-full border-4 border-white shadow-xl ring-4 ring-sand-200"></div>
                <div className="timeline-content relative z-10 ml-10 sm:ml-20 md:ml-0 md:w-5/12 md:pr-8 lg:pr-12">
                  <Card className="bg-white/90 backdrop-blur-md border-2 border-peach-200 shadow-2xl hover:shadow-3xl transition-all duration-500 animate-fade-in overflow-hidden">
                    <CardHeader className="pb-3 sm:pb-4 bg-gradient-to-r from-sand-50 to-beach-50 flex justify-center items-center">
                      <h3 className="text-lg sm:text-xl font-text font-bold text-coral text-center">NJ NAACH 1.0 PLACINGS</h3>
                    </CardHeader>
                    <CardBody className="p-4 sm:p-6">
                      <div className="text-center">
                        {/* 3 Bubbles in 1 row for RAS Circuit */}
                        <div className="space-y-4 mt-4">
                          <div className="flex flex-col items-center">
                            <h4 className="text-base sm:text-lg font-text font-bold text-coral mb-3">Raas All Stars</h4>
                            <div className="flex space-x-3 sm:space-x-4" style={{ transform: 'translateX(4%)' }}>
                              <div className="text-center">
                                <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">1st Place</p>
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-yellow-300 overflow-hidden">
                                  <img 
                                    src="/teams/UIUC.jpg" 
                                    alt="UIUC" 
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <p className="text-xs text-teal-600 font-text font-bold">Illini Raas</p>
                              </div>
                              <div className="text-center">
                                <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">2nd Place</p>
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-gray-400 to-gray-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-gray-300 overflow-hidden">
                                  <img 
                                    src="/teams/UMD.jpg" 
                                    alt="UMD" 
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <p className="text-xs text-teal-600 font-text font-bold">UMD Entouraas</p>
                              </div>
                              <div className="text-center">
                                <p className="text-xs sm:text-sm font-text font-bold text-coral mb-2 font-semibold">3rd Place</p>
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-orange-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg border-2 border-orange-300 overflow-hidden">
                                  <img 
                                    src="/teams/UCSD.jpg" 
                                    alt="UCSD" 
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <p className="text-xs text-teal-600 font-text font-bold">UCSD Raas Ruckus</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>

              {/* NAACH 1.0 Board - LEFT SIDE (BOTTOM) */}
              <div className="timeline-item relative">
                <div className="timeline-marker absolute left-2 sm:left-4 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-r from-peach to-lavender rounded-full border-4 border-white shadow-xl ring-4 ring-lavender-200"></div>
                
                {/* Large Scrapbook Image - RIGHT SIDE */}
                <div className="absolute right-0 md:right-0 md:left-auto md:w-5/12 md:pl-8 lg:pl-12 top-0 pointer-events-none -z-10 opacity-25 sm:opacity-40 md:opacity-100 md:z-0">
                  <div className="relative inline-block transform -translate-y-80 -rotate-6">
                    {/* Tape pieces - diagonal corners */}
                    <div className="absolute -top-3 -left-3 w-12 h-6 bg-yellow-200 opacity-80 transform -rotate-12 z-10 rounded-sm shadow-md"></div>
                    <div className="absolute -top-3 -right-3 w-12 h-6 bg-yellow-200 opacity-80 transform rotate-12 z-10 rounded-md"></div>
                    <div className="absolute -bottom-3 -left-3 w-12 h-6 bg-yellow-200 opacity-80 transform rotate-12 z-10 rounded-md"></div>
                    <div className="absolute -bottom-3 -right-3 w-12 h-6 bg-yellow-200 opacity-80 transform -rotate-12 z-10 rounded-sm shadow-md"></div>
                    
                    {/* Large Image */}
                    <img 
                      src="/images/board1.0.jpg" 
                      alt="NAACH 1.0 Board" 
                      className="w-96 h-96 sm:w-[26rem] sm:h-[26rem] lg:w-[36rem] lg:h-[36rem] object-cover rounded-xl shadow-2xl border-4 border-white"
                    />
                  </div>
                </div>
                
                <div className="timeline-content relative z-10 ml-10 sm:ml-20 md:ml-0 md:w-5/12 md:pr-8 lg:pr-12">
                  <Link as={RouterLink} to="/board-1-0" className="block">
                    <Card className="bg-white/90 backdrop-blur-md border-2 border-peach-200 shadow-2xl hover:shadow-3xl transition-all duration-500 transform hover:scale-105 cursor-pointer overflow-hidden">
                      <CardHeader className="pb-3 sm:pb-4 bg-gradient-to-r from-cream-50 to-peach-50 flex justify-center items-center">
                        <h3 className="text-lg sm:text-xl font-text font-bold text-coral text-center">NJ NAACH 1.0 Board</h3>
                      </CardHeader>
                      <CardBody className="p-4 sm:p-6">
                        <div className="text-center">
                          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r from-beach-400 to-sand-400 rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg">
                            <span className="text-white text-lg sm:text-xl">🎬</span>
                          </div>
                          <p className="text-teal-600 font-text text-sm sm:text-base font-medium mb-2">
                            The founding executive board of NJ Naach
                          </p>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
} 